/**
 * Function that takes an arbritrary number of functions and then executes them serially
 * This allows for the composition of multiple functions on the same event in say vue templates
 * ie. @click="fZip(showMe(), countMe(), updateMe(), emitMe())"
 * @param {...function} funcArgs takes an arbitrary number of functions and executes them serially
 * @return function
 */
export function fZip(...funcArgs) {
  return () => {
    for (const arg of funcArgs) {
      arg()
    }
  }
}
/**
 * Function that takes an arbitrary number of functions and then executes them serially while passing on arguments
 * that it is given.
 * This allows for the composition of functions as fZip but serves more as an event based handler where the passed
 * event is needed for processing.
 * ie. @click="fZip(showMe, countMe, updateMe, emitMe)"
 * @param {...function} funcArgs takes an arbitrary number of functions and executes them serially
 * @return function
 */
export function fZipArg(...funcArgs) {
  return (...args) => {
    for (const arg of funcArgs) {
      arg(...args)
    }
  }
}
